import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_shipping_price_book_ext_RowClass} from '../../../dbschema';

export class ShippingPriceBookExtensionContainerModel extends BaseContainerModel {
  bl_fi_mst_shipping_price_book_ext: bl_fi_mst_shipping_price_book_ext_RowClass = new bl_fi_mst_shipping_price_book_ext_RowClass();
}
